import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { Section } from './Section';


const SideSectionContaner: React.FC<PropsWithChildren<{
    title: string,
    noMargin?: boolean,
}>> = ({ children, title, noMargin = false }) => {

    return (
        <Section
            title={title}
            // color={'#fff'}
            noMargin={noMargin}
        >
            {children}
        </Section>
    )
}

const SideText: React.FC<{
    text: string,
}> = ({ text }) => {

    return (
        <Box
            component='p'
            sx={{
                m: 0,
                lineHeight: '1em',
                fontSize: '0.9em',
            }}
        >
            {text}
        </Box>
    )
}

const SideSection: React.FC<{
    title?: string,
    text: string,
    pretitle?: string,
}> = ({ title, text, pretitle }) => {

    return (
        <Box sx={{ mb: title ? 3 : 1 }}>
            {
                pretitle && <SideText text={pretitle} />
            }
            {
                title && <Box
                    component='h4'
                    sx={{
                        m: 0,
                    }}
                >
                    {title}
                </Box>
            }
            <SideText text={text} />
        </Box>
    )
}

export { SideSectionContaner, SideSection, SideText };
